var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configurator-detail",class:{ 'is-expert': _vm.mode=='expert' }},[_c('Detail',{attrs:{"item":_vm.item,"mode":_vm.mode}}),_c('DetailFooter',{attrs:{"item":_vm.item,"mode":_vm.mode,"projectPdf":_vm.projectPdf}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }